"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var styles = require('./MessageAdListItem.scss');
var classNames = require('classnames/bind').bind(styles);
var ThreeLineViewSubjectLine = /** @class */ (function (_super) {
    tslib_1.__extends(ThreeLineViewSubjectLine, _super);
    function ThreeLineViewSubjectLine() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThreeLineViewSubjectLine.prototype.render = function () {
        // We need to give this div a pre-defined height as FAN ad does not have the sender text at the first loading
        // Without the predefined height, we will see a blank UI re-flow
        var subjectDivClass = classNames(this.props.isUnread
            ? styles.secondRowThreeColumnUnread
            : styles.secondRowThreeColumnUnread, this.props.subjectTexts ? null : styles.messageLineHeightReadingPaneOn);
        return (React.createElement("div", { className: subjectDivClass },
            React.createElement("div", { className: classNames(styles.secondLineTextThreeColumn, styles.messageLineHeightReadingPaneOn, 'fbAdSubtitle', 'fbAdLink') },
                this.props.originalPriceTexts && (React.createElement("span", { className: styles.originalPrice },
                    this.props.originalPriceTexts,
                    "\u00A0")),
                this.props.currentPriceTexts && (React.createElement("span", null,
                    this.props.currentPriceTexts,
                    " \u00A0")),
                this.props.subjectTexts)));
    };
    ThreeLineViewSubjectLine = tslib_1.__decorate([
        mobx_react_1.observer
    ], ThreeLineViewSubjectLine);
    return ThreeLineViewSubjectLine;
}(React.Component));
exports.default = ThreeLineViewSubjectLine;
//# sourceMappingURL=ThreeLineViewSubjectLine.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-list-view/lib/components/ThreeLineViewSubjectLine.js
// module id = 6007
// module chunks = 67